export const categories = [
  {
    id: "shoes",
    namePt: "Shoes",
    nameEn: "Tênis",
    link: "https://kaspreadsheet.com/category-911-Shoes.html",
    count: "2.800+"
  },
  {
    id: "hoodies",
    namePt: "Hoodies/Sweaters",
    nameEn: "Moletons",
    link: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    count: "1.500+"
  },
  {
    id: "tshirts",
    namePt: "T-Shirts",
    nameEn: "Camisetas",
    link: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    count: "3.200+"
  },
  {
    id: "jackets",
    namePt: "Jackets",
    nameEn: "Jaquetas",
    link: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    count: "980+"
  },
  {
    id: "pants",
    namePt: "Pants/Shorts",
    nameEn: "Calças/Shorts",
    link: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    count: "1.100+"
  },
  {
    id: "headwear",
    namePt: "Headwear",
    nameEn: "Chapéus/Bonés",
    link: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    count: "640+"
  },
  {
    id: "sets",
    namePt: "Sets",
    nameEn: "Conjuntos",
    link: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    count: "430+"
  },
  {
    id: "underwear",
    namePt: "Underwear/Underpants",
    nameEn: "Roupa Íntima",
    link: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    count: "380+"
  },
  {
    id: "jersey",
    namePt: "Jersey",
    nameEn: "Camisas Esportivas",
    link: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    count: "720+"
  },
  {
    id: "accessories",
    namePt: "Accessories",
    nameEn: "Acessórios",
    link: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    count: "1.900+"
  },
  {
    id: "bags",
    namePt: "Bags",
    nameEn: "Bolsas",
    link: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    count: "850+"
  },
  {
    id: "belts",
    namePt: "Belts",
    nameEn: "Cintos",
    link: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    count: "310+"
  },
  {
    id: "perfumes",
    namePt: "Perfumes",
    nameEn: "Perfumes",
    link: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    count: "520+"
  },
  {
    id: "other",
    namePt: "Other Stuff",
    nameEn: "Outros Itens",
    link: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    count: "1.400+"
  }
];